import {
    gblock,
    gblock_two,
    wordpress
} from './styles'

export default function WordpressStyle() {
    return <><style>{gblock}</style><style>{gblock_two}</style><style>{wordpress}</style></>
}